module.exports = __webpack_public_path__ + "img/infinity.49e2ebcd.svg";